
export class Constants {
  public static languages = [
    {name: 'Arabic', id: 'ar'},
    {name: 'Argentinian', id: 'es-AR'},
    {name: 'Azerbaijani', id: 'az'},
    {name: 'Bangla (Bengali)', id: 'bn'},
    {name: 'Bhojpuri', 'id': 'bho'},
    {name: 'Bulgarian', id: 'bg'},
    {name: 'Catalan', id: 'ca'},
    {name: 'Chinese Cantonese', id: 'yue'},
    {name: 'Chinese Mandarin', id: 'cmn'},
    {name: 'Chinese, Tradt\'l Script', id: 'zh-Hant'},
    {name: 'Chinese, Simplified', id: 'zh-Hans'},
    {name: 'Czech', id: 'cs'},
    {name: 'Danish', id: 'da'},
    {name: 'Dutch', id: 'nl'},
    {name: 'English', id: 'en'},
    {name: 'English Descriptive Audio', id: 'en-x-da'},
    {name: 'Estonian', id: 'et'},
    {name: 'Farsi', id: 'fa'},
    {name: 'Filipino (Tagalog)', id: 'fil'},
    {name: 'Finnish', id: 'fi'},
    {name: 'French, Canadian', id: 'fr-CA'},
    {name: 'French', id: 'fr'},
    {name: 'French, Parisian', id: 'fr-FR'},
    {name: 'Gaelic, Scottish', id: 'gd'},
    {name: 'Georgian', id: 'ka'},
    {name: 'German', id: 'de'},
    {name: 'Gujarati', id: 'gu'},
    {name: 'Greek', id: 'el'},
    {name: 'Hebrew', id: 'he'},
    {name: 'Hindi', id: 'hi'},
    {name: 'Hungarian', id: 'hu'},
    {name: 'Icelandic', id: 'is'},
    {name: 'Indonesian', id: 'id'},
    {name: 'Inuktitut', id: 'iu'},
    {name: 'Irish', id: 'ga'},
    {name: 'Italian', id: 'it'},
    {name: 'Japanese', id: 'ja'},
    {name: 'Kannada', id: 'kn'},
    {name: 'Kazakh', id: 'kk'},
    {name: 'Korean', id: 'ko'},
    {name: 'Latvian', id: 'lv'},
    {name: 'Lithuanian', id: 'lt'},
    {name: 'Malay', id: 'ms'},
    {name: 'Malayalam', id: 'ml'},
    {name: 'Macedonian', id: 'mk'},
    {name: 'Maori', id: 'mi'},
    {name: 'Marathi', id: 'mr'},
    {name: 'M&E - Music and Effects', id: 'zxx-x-me'},
    {name: 'M&E - Music only', id: 'zxx-x-music'},
    {name: 'M&E - Effects only', id: 'zxx-x-effects'},
    {name: 'No linguistic content', id: 'zxx'},
    {name: 'Nepali', id: 'ne'},
    {name: 'Norwegian', id: 'no'},
    {name: 'Polish', id: 'pl'},
    {name: 'Portuguese, Brazilian', id: 'pt-BR'},
    {name: 'Portuguese, Brazilian Descriptive Audio', id: 'pt-BR-x-da'},
    {name: 'Portuguese, European', id: 'pt-PT'},
    {name: 'Portuguese', id: 'pt'},
    {name: 'Punjabi', id: 'pa'},
    {name: 'Romanian', id: 'ro'},
    {name: 'Russian', id: 'ru'},
    {name: 'Serbian', id: 'sr'},
    {name: 'Sinhala', id: 'si'},
    {name: 'Slovak', id: 'sk'},
    {name: 'Slovenian', id: 'sl'},
    {name: 'Spanish', id: 'es'},
    {name: 'Spanish, Castilian', id: 'es-ES'},
    {name: 'Spanish, Latin American', id: 'es-419'},
    {name: 'Swahili', id: 'sw'},
    {name: 'Swedish', id: 'sv'},
    {name: 'Taiwanese Hokkien', id: 'nan-TW'},
    {name: 'Taiwanese Mandarin (Guoyu)', id: 'zh-TW'},
    {name: 'Telugu', id: 'te'},
    {name: 'Tamil', id: 'ta'},
    {name: 'Thai', id: 'th'},
    {name: 'Turkish', id: 'tr'},
    {name: 'Ukrainian', id: 'uk'},
    {name: 'Urdu', id: 'ur'},
    {name: 'Vietnamese', id: 'vi'},
    {name: 'Yoruba', id: 'yo'},
    {name: 'Undetermined', id: 'und'},
  ];

  // Spellings that are no longer offered but still sit in existing records, so they have to render
  // with a name instead of the raw tag. Nothing needs rewriting: the backend already treats each of
  // these as the code it maps to.
  //
  //  - the M&E stems, from before they moved onto the zxx ("no linguistic content") base;
  //  - tl/tgl, which the backend canonicalises to fil (CLDR aliases Tagalog to Filipino, so every
  //    spelling of it ends up stored as fil whatever was picked here).
  public static legacyLanguageAliases: Record<string, string> = {
    'x-me': 'zxx-x-me',
    'x-music': 'zxx-x-music',
    'x-effects': 'zxx-x-effects',
    'tl': 'fil',
    'tgl': 'fil',
  };
}
